export default "/static/media/doc.9180491f41a0627961369db443806fee.svg";